import { Box } from "@mui/material";
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { InputBase, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { wilayas } from "../../data/mockData";



import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../config";

const Contacts = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [mockDataContacts, setMockDataContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [rowCount, setRowCount] = useState(0);
  const [search, setSearch] = useState("");
  const emojis = ["⌛️", "🚗", "✔️", "❌"];

  function StateComponent({state, setState}) {
    return (
      <Box>
      {emojis.map((emoji, index) => (
        <span key={index} className={state === index  ? "state state-active" : "state"} onClick={() => setState(index + 1)}>{emoji}</span>
      ))}
      </Box>
    )
  }

  // use effect search page
  useEffect(() => {
    fetchContacts();
  }, [page, search]);

  const fetchContacts = async () => {
    setLoading(true);

    try {
      const authToken = sessionStorage.getItem("authToken");
      const response = await fetch(`${API_BASE_URL}/admin/rides`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ authToken, page, search}),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch contacts');
      }



      const data = await response.json();
      console.log(data)
      setMockDataContacts(data.rides);
      setRowCount(data.total);
      setLoading(false);

    } catch (error) {
      console.error('Error fetching contacts:', error);
      return [];
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    fetchContacts();
  }, []);
  
  const columns = [
    { field: "id", headerName: "ID", flex: 0.5 },
    { 
      field: "type", 
      headerName: "Type",     
      renderCell: ({ row: { type } }) => {
        // Détermine l'image à afficher en fonction du type
        const imageSrc = type === 1 ? "/assets/cars/1.png" : "/assets/cars/6.png"; // Changez le chemin si nécessaire
    
        return (
          <img src={imageSrc} alt="Car" style={{ width: '50px', height: 'auto' }} />
        );
      }
    },
    
    { field: "user_id", headerName: "User ID", flex: 1 },
    { field: "driver_id", headerName: "Driver ID", flex: 1 },
    { field: "distance", headerName: "Distance", flex: 1 },
    { field: "duration", headerName: "Duration", flex: 1 },
    { field: "price", headerName: "Price", flex: 1 },
    {
      field: "state",
      headerName: "State",
      renderCell: (params) => {
        return <StateComponent state={params.value} setState={(value) => console.log(value)} />;
      }
    },


        { field: "date", headerName: "Date", flex: 1 },
    { field: "note", headerName: "Note", flex: 1 },
    {
      field: "car",
      headerName: "Car",
      flex: 1,
      renderCell: ({ row: { car } }) => {
        // Assurez-vous que `car` est une chaîne correspondant au nom de fichier ou ID de l'image
        const imageSrc = `/assets/cars/${car}.png`; // Assurez-vous que les fichiers ont l'extension correcte
    
        return (
          <img 
            src={imageSrc} 
            alt="Car" 
            style={{ width: '50px', height: 'auto' }} // Ajustez la taille selon vos besoins
          />
        );
      }
    },
    {
      field: "map",
      headerName: "Map",
      flex: 1,
      renderCell: ({ row: { id } }) => {
    
        return (
          <Link to={`/ride/${id}`}>
            <img 
              src="/assets/end.png"
              alt="Map" 
              style={{ width: 'auto', height: '20px' }} // Adjust the size as needed
            />
          </Link>
        );
      }
    }
    



  ];


  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

  return (
    <Box m="20px">
      <Header
        title="Drivers"
        subtitle="List of Drivers for Future Reference"
      />
       <Box
        display="flex"
        backgroundColor={colors.primary[400]}
        borderRadius="3px"
      >
        <InputBase 
        // its value is 'search'
      value={search}
      // when change set the value of search to the value of the input
      onChange={(e) => setSearch(e.target.value)}


        sx={{ ml: 2, flex: 1 }} placeholder="Search" />
        <IconButton type="button" sx={{ p: 1 }}>
          <SearchIcon />
        </IconButton>
      </Box>
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={mockDataContacts}
          columns={columns}
         slots={{ toolbar: CustomToolbar }}
          pagination
          autoPageSize
          rowCount={rowCount}
          loading={loading}
          paginationMode="server"
          onPaginationModelChange={(newModel) => {
            setPage(newModel.page + 1);
          }
          }


         // onPageChange={(newPage) => setPage(newPage)}

          

          
        />
      </Box>
    </Box>
  );
};

export default Contacts;
